import { useCallback} from "react";
import { useDispatch, useSelector } from "react-redux";
import * as DialogActions from '../redux/actions/DialogAction'


export const useDialogService = ()=>{  

    const show = useSelector((state)=>{
        return state.dialog.show;
    })

    const header = useSelector((state)=>{
        return state.dialog.header;
    })

    const body = useSelector((state)=>{
        return state.dialog.body;
    })
    const icon = useSelector((state)=>{
        return state.dialog.icon;
    })

    const labelOk = useSelector((state)=>{
        return state.dialog.labelOk
    })

    const labelCancel = useSelector((state)=>{
        return state.dialog.labelCancel;
    })

    const severity = useSelector((state)=>{
        return state.dialog.severity;
    })

    const HandleOk = useSelector((state)=>{
        return state.dialog.okHandler;
    })

    const HandleCancel = useSelector((state)=>{
        return state.dialog.cancelHandler;
    })

    const dispatchDialog = useDispatch();

    const ShowDialog = useCallback(async (header, body, icon, labelOk, labelCancel, severity, onOk, onCancel)=>{
        var action = DialogActions.ShowDialog(header, body, icon, labelOk, labelCancel, severity,  onOk, onCancel);
        dispatchDialog(action); 
      

    }, [dispatchDialog])

    const HideDialog = useCallback(()=>{
        var action = DialogActions.HideDialog();
        dispatchDialog(action); 

    }, [dispatchDialog])
    

    return {data:{show, header, body, icon, labelOk, labelCancel, severity}, actions:{ShowDialog, HideDialog, HandleOk, HandleCancel}}
}


